import { components, OptionProps } from 'react-select';
import React from 'react';

import { ISelectorOption } from 'types/ISelectorOption';

const DropdownIndicator: React.FC<OptionProps<ISelectorOption, false>> = ({
  children,
  ...props
}) =>
  components.DropdownIndicator && (
    <components.DropdownIndicator {...props}>
      <label>▼</label>
    </components.DropdownIndicator>
  );

export default DropdownIndicator;
export const styledSelect = {
  components: {
    DropdownIndicator,
  },
};
